module.exports = __webpack_public_path__ + "static/media/07_CORTININHA_SEM_BOJO_LISO_01.15fb3a3b.jpg";